import * as React from 'react';
import { View, StyleProp, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const ForumActivitySvg = React.memo(
    (props: {
        size?: number;
        primaryColor?: string;
        containerStyle?: StyleProp<ViewStyle>;
    }) => {
        const size = props.size ?? 22;
        const width = size;
        const height = (size * (19/22));
        return (
            <View style={props.containerStyle}>
                <Svg
                    width={width}
                    height={height}
                    viewBox="0 0 22 19"
                    fill="none"
                    {...props}
                >
                    <Path
                        d="M4.723 16.442l2.81-2.74a.629.629 0 01.441-.181l2.781-.001c-.502.251-.924.629-1.237 1.298h-1.29l-3.67 3.58a.636.636 0 01-1.114-.435v-3.145H1.551c-.427 0-.815-.178-1.094-.463A1.588 1.588 0 010 13.24V1.578C0 1.147.177.75.458.466.738.18 1.128 0 1.551 0H16.09c.423 0 .813.178 1.094.465.28.284.456.678.456 1.112v4.009a3.062 3.062 0 00-1.278-.546V1.577a.278.278 0 00-.082-.194.27.27 0 00-.19-.083H1.55a.27.27 0 00-.189.084.28.28 0 00-.083.193v11.665a.28.28 0 00.273.277h2.533c.352 0 .639.29.639.65v2.273zm5.968.766a.162.162 0 01-.161-.163c0-.047.006-.093.018-.139.258-2.078 1.16-2.114 2.297-2.416.34-.09.96-.282 1.32-.604.199-.177.32-.394.272-.655-.275-.258-.486-.538-.534-1.072h-.033a.44.44 0 01-.218-.057c-.152-.088-.235-.256-.275-.447-.048-.23-.105-.884.201-1.014l.003-.001c-.038-.722.082-1.864-.647-2.088 1.438-1.808 3.097-2.79 4.342-1.183 1.387.074 2.006 2.153 1.145 3.272h-.037c.307.13.249.785.202 1.014-.04.191-.123.36-.275.447a.44.44 0 01-.218.058h-.033c-.048.533-.26.813-.534 1.071-.048.261.073.478.271.655.36.322.98.514 1.32.604 1.137.302 2.04.338 2.298 2.416a.572.572 0 01.018.139c0 .09-.072.163-.161.163H10.69zM4.387 5.845a.645.645 0 01-.639-.65c0-.359.287-.65.64-.65h8.711c.354 0 .64.291.64.65 0 .359-.286.65-.64.65H4.387zm0 3.847a.645.645 0 01-.638-.65c0-.359.286-.65.639-.65h5.935c.353 0 .639.291.639.65 0 .359-.286.65-.64.65H4.389z"
                        fill={props.primaryColor ?? '#F35E2E'}
                    />
                </Svg>
            </View>
        );
    },
);

ForumActivitySvg.displayName = 'ForumActivitySvg';

export { ForumActivitySvg };
